import { useState } from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { LockOpen, Lock } from '@mui/icons-material'

const LockingTooltip = ({ children, title, ...props }) => {
  const [open, setOpen] = useState(false)
  const [locked, setLocked] = useState(false)

  return (
    <Tooltip
      {...props}
      arrow
      title={
        <Box>
          <Box display="flex" alignItems="center" justifyContent="flex-end">
            {locked ? (
              <IconButton onClick={() => setLocked(false)}>
                <Lock style={{ fontSize: 16 }} />
              </IconButton>
            ) : (
              <IconButton onClick={() => setLocked(true)}>
                <LockOpen style={{ fontSize: 16 }} />
              </IconButton>
            )}
          </Box>
          {title}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: '12px',
            borderRadius: '6px',
            boxShadow: '8px 14px 38px rgb(39 44 49 / 6%), 1px 3px 8px rgb(39 44 49 / 3%);',
            background: '#fff',
            border: '1px solid #dde1f3',
            color: '#4b4f60',
            padding: '8px',
          },
        },
        arrow: {
          sx: {
            color: 'white',
          },
        },
      }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => {
        locked ? setOpen(true) : setOpen(false)
      }}
    >
      {children}
    </Tooltip>
  )
}

export default LockingTooltip
